var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b',{staticClass:"place"},[_vm._v("Places you lived")]),_c('hr'),_c('p',{staticClass:"place"},[_c('b',[_vm._v("Cameroon, South Africa")])]),_c('p',{staticClass:"place"},[_vm._v(" Current City ")]),_c('hr'),_c('p',{staticClass:"place"},[_c('b',[_vm._v("New York, United States")])]),_c('p',{staticClass:"place"},[_vm._v(" Home City ")])])
}]

export { render, staticRenderFns }